import { render } from "./ManageSysParm.vue?vue&type=template&id=789329ca&scoped=true"
import script from "./ManageSysParm.vue?vue&type=script&lang=js"
export * from "./ManageSysParm.vue?vue&type=script&lang=js"

import "./ManageSysParm.vue?vue&type=style&index=0&id=789329ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789329ca"]])

export default __exports__